/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { InlineSelect } from '@ui/molecules/inputs/inline/InlineSelect';
import { translate } from '@utils/i18n';
import { FiltererOptions, IndexNamespace, SorterOptions } from '../constants';
import useFilters from '../hooks/useFilters';
import useUpdateFilters from '../hooks/useUpdateFilters';
import { useActivityFeedContext } from '../hooks/useActivityFeedCtx';
function FilterSection({ notesEnabled, availableFilters, horizontal = false }) {
    var _a;
    const { data, updateShowDetails } = useFilters();
    const updateFilters = useUpdateFilters();
    const { scrollToBottom, scrollToTop } = useActivityFeedContext();
    const filterOptions = Object.keys(FiltererOptions)
        .filter((key) => {
        const filterOption = FiltererOptions[key];
        // Show filter only if it's available for this page type and either notes are enabled or it's not the Notes filter
        return ((availableFilters ? availableFilters.includes(filterOption) : true) &&
            (notesEnabled || filterOption !== FiltererOptions.Notes));
    })
        .map((key) => ({
        label: translate(FiltererOptions[key], { namespace: IndexNamespace }),
        value: FiltererOptions[key]
    }));
    const sorterOptions = Object.values(SorterOptions).map((key) => ({
        value: key,
        label: (React.createElement("span", { className: "sorterOptionContainer" },
            React.createElement("i", { className: `fa-light fa-arrow-${key === SorterOptions.OldestToNewest ? 'up' : 'down'}-wide-short` }),
            translate(key, { namespace: IndexNamespace })))
    }));
    const onMultiChangeFilters = (newValues) => {
        updateFilters({ filters: newValues });
    };
    const detailsOptions = [
        {
            value: 'expanded',
            label: translate('show_all_details', { namespace: IndexNamespace })
        },
        {
            value: 'collapsed',
            label: translate('hide_all_details', { namespace: IndexNamespace })
        }
    ];
    return (React.createElement("div", { className: `activity__filter${horizontal ? ' activity__filter--horizontal' : ''}` },
        React.createElement("div", null,
            React.createElement(InlineSelect, { options: sorterOptions, value: (_a = data === null || data === void 0 ? void 0 : data.sort) !== null && _a !== void 0 ? _a : SorterOptions.OldestToNewest, onChange: (value) => {
                    updateFilters({ sort: value });
                    if (value === SorterOptions.OldestToNewest) {
                        scrollToBottom();
                    }
                    else {
                        scrollToTop();
                    }
                }, label: translate('order_by', { namespace: IndexNamespace }) })),
        React.createElement("div", null,
            React.createElement(InlineSelect, { options: detailsOptions, value: (data === null || data === void 0 ? void 0 : data.showDetails) || 'collapsed', onChange: updateShowDetails, label: translate('show_details', { namespace: IndexNamespace }) })),
        React.createElement("div", null,
            React.createElement(InlineSelect, { options: filterOptions, multiple: true, values: (data === null || data === void 0 ? void 0 : data.filters) || [], onMultiChange: onMultiChangeFilters, label: translate('show_updates', { namespace: IndexNamespace }) }))));
}
export default React.memo(FilterSection);
